import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'bh-faq',
  templateUrl: './bh-faq.component.html',
  styleUrls: ['./bh-faq.component.scss']
})
export class BhFaqComponent implements OnInit {
  @Input() text: string;
  @Input('type') set _type(_type) {
    if (_type) {
      this.interface.type = _type;
    }
  }
  @Input('exam') set _exam(_exam) {
    if (_exam) {
      this.interface.exam = _exam;
      this.interface.list = this.interface.faq.filter(item => item.exam === _exam);
    }
  }

  interface = {
    type: '',
    exam: undefined,
    list: [],
    faq: [
      {
        exam:'k12',
        question: "Do I have access to only one grade?",
        answer: "You will have access to our entire Kindergarten through 8th grade online resources. We understand the importance of high-quality resources and affordability. We want to provide you with everything you need in one place, so with one simple subscription you are able to access resources and practice from all grades in Kindergarten through 8th grade. Your subscription includes 4 eBooks for one grade level only, however, all other resources (excluding eBooks) you have open access. "
      },
      {
        exam:'k12',
        question: "What are the 4 eBooks that are included in the subscription?",
        answer: "Your subscription comes included with 4 eBooks (Math, ELA, Science, and Social Studies) for a specific grade level of your choice. These are comprehensive and complete workbooks. You will be able to download or print pages from the eBook. We are proud to offer complete and rigorous materials at an affordable price all in one subscription.  "
      },
      {
        exam:'k12',
        question: "How do I cancel my subscription?",
        answer: "Super simple! Once logged in, click on the top right profile icon and click on \"Plants & Billing\". You can manage everything there."
      },
      {
        exam:'k12',
        question: "Can I purchase physical copies of your workbooks?",
        answer: "Absolutely, we offer over 100+ workbooks from grades K through 8 in various subjects. If you want to purchase physical copies, go to argoprep.com/store"
      },
      {
        exam:'shsat',
        question: "Do I get access to your SHSAT workbooks?",
        answer: "Yes! You will automatically get access to our 4 comprehensive digital eBooks as well. Our SHSAT Book 1 goes over the Revising/Editing section, SHSAT Book 2 and 3 go over 7th grade math standards and advanced SHSAT questions and finally SHSAT Book 4 gives you 5 full-length diagnostic practice. These 4 eBooks alone contain 3,000 practice questions."
      },
      {
        exam:'shsat',
        question: "How will ArgoPrep help me prepare for this SHSAT exam?",
        answer: "Our SHSAT online program offers you everything you need to know for the exam. Our video lectures covers the exam and the foundational concepts that you must know. We have over 32+ hours of detailed video lectures to boost your confidence during test day. Furthermore, you will also be able to access practice quizzes and drills."
      },
      {
        exam:'shsat',
        question: "Do you offer a free trial?",
        answer: "Yes! We offer a 24 hour free trial so you can purchase our subscription with confidence. Don’t like what you see? Simply cancel your subscription before 24 hours and you will not be charged."
      },
      {
        exam:'shsat',
        question: "Why is ArgoPrep the best in SHSAT test preparation?",
        answer: "ArgoPrep is an industry leader when it comes to preparing students for the Specialized High School Exam. Our materials and test prep workbooks for the SHSAT exam have been used by over 40,000+ students in the past four years. We offer you fun and comprehensive video lectures and guide you through all of the topics you must master before the exam. There’s a reason why so many New York City parent’s trust our program. Purchase your subscription today, you have nothing to lose! We offer a 24 hour free trial."
      },
    ]
  }

  constructor() { }

  ngOnInit(): void {
  }

}
